"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Play = void 0;
var _react = _interopRequireDefault(require("react"));
var Play = exports.Play = function Play() {
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: "11",
    height: "13",
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.4375 5.53906L2.1875 0.664062C1.50781 0.265625 0.5 0.664062 0.5 1.625V11.375C0.5 12.2656 1.4375 12.8047 2.1875 12.3594L10.4375 7.48438C11.1641 7.03906 11.1641 5.98438 10.4375 5.53906Z",
    fill: "white"
  }));
};